var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningCriticalIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48633 0L12 3.51367V8.48633L8.48633 12H3.51367L0 8.48633V3.51367L3.51367 0H8.48633ZM3.93359 1.00684L1.00684 3.93359V8.07324L3.93359 11H8.07324L11 8.07324V3.93359L8.07324 1.00684H3.93359ZM8.40039 4.30664L6.70703 6L8.40039 7.69336L7.69336 8.40039L6 6.70703L4.30664 8.40039L3.59961 7.69336L5.29297 6L3.59961 4.30664L4.30664 3.59961L6 5.29297L7.69336 3.59961L8.40039 4.30664Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningCriticalIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning_Critical_icon.6bc7d214d8e8e682965a925e3f86dc5c.svg";